// Unifies guest cart (localStorage) and server cart (FastAPI).
import {
  getCart as apiGetCart,
  addCartItem as apiAddCartItem,
  updateCartItem as apiUpdateCartItem,
  deleteCartItem as apiDeleteCartItem,
  clearCart as apiClearCart,
} from "../api/api";
import {
  getGuestCart,
  addGuestItem,
  updateGuestItem,
  removeGuestItem,
  clearGuestCart,
} from "./guestCart";

const EV = "cart:updated";
export const isLoggedIn = () => Boolean(localStorage.getItem("accessToken"));

// ----- READ -----
export async function getCartUnified() {
  if (isLoggedIn()) {
    const data = await apiGetCart(); // backend CartResponse
    return data;
  }
  return getGuestCart();
}

// ----- ADD -----
export async function addProductToCart(product, qty = 1) {
  if (isLoggedIn()) {
    await apiAddCartItem({ product_id: product.id, quantity: qty, discount_amount: 0 });
    window.dispatchEvent(new CustomEvent(EV));
    return apiGetCart();
  }
  const data = addGuestItem(product, qty);
  return data;
}

// ----- UPDATE QTY -----
export async function updateCartQty(item, qty) {
  if (isLoggedIn()) {
    // server item ids are cart_item ids; item.id is required
    await apiUpdateCartItem(item.id, { quantity: qty, discount_amount: item.discount_amount ?? 0 });
    window.dispatchEvent(new CustomEvent(EV));
    return apiGetCart();
  }
  // guest: use product_id
  const data = updateGuestItem(item.product_id, qty);
  return data;
}

// ----- REMOVE -----
export async function removeCartLine(item) {
  if (isLoggedIn()) {
    await apiDeleteCartItem(item.id);
    window.dispatchEvent(new CustomEvent(EV));
    return apiGetCart();
  }
  const data = removeGuestItem(item.product_id);
  return data;
}

// ----- CLEAR -----
export async function clearUnifiedCart() {
  if (isLoggedIn()) {
    await apiClearCart(); // DELETE /cart/clear → CartResponse
    window.dispatchEvent(new CustomEvent(EV));
    return apiGetCart();
  }
  clearGuestCart();
  return getGuestCart();
}

// ----- MERGE (run after login/redirect back) -----
export async function mergeGuestCartIntoServerIfAny() {
  if (!isLoggedIn()) return null;
  const guest = getGuestCart();
  if (!guest?.items?.length) return null;

  for (const it of guest.items) {
    try {
      await apiAddCartItem({ product_id: it.product_id, quantity: it.quantity, discount_amount: 0 });
    } catch (e) {
      // swallow one-off failures; continue merging the rest
      console.error("merge item failed", it, e);
    }
  }
  clearGuestCart(); // prevent double-merge
  window.dispatchEvent(new CustomEvent(EV));
  return apiGetCart();
}
